export enum LIST {
  REQUEST = '@@ASSESSMENT/LIST/REQUEST',
  SUCCESS = '@@ASSESSMENT/LIST/SUCCESS',
  FAILURE = '@@ASSESSMENT/LIST/FAILURE'
}
